import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const requestInterceptor: HttpInterceptorFn = (req, next) => {
  const modifiedReq = req.clone({
    setHeaders: { 'content-type': 'application/json' },
  });

  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const message =
        (error.error?.detail && error.error?.detail[0]?.msg) || error.error;
      return throwError(() => message);
    })
  );
};
